<form class="filter" #formElement [formGroup]="form">
    <mat-form-field>
        <mat-label>Fecha</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="date" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>

        <mat-error *ngIf="f.date.errors && f.date.errors.required">
            Ingrese la fecha
        </mat-error>
    </mat-form-field>



    <div class="full-width">
        <patient-autocomplete formControlName="patient"></patient-autocomplete>
    </div>



    <div class="search-actions">
        <mat-checkbox formControlName="finished">Finalizadas</mat-checkbox>
    </div>
</form>
